export default {
    system_alert_logs_tab_id: "Id",
    system_alert_logs_tab_created_on: "Creación",
    system_alert_logs_tab_unit_time: "Fecha Dispositivo",
    system_alert_logs_tab_type: "Tipo",
    system_alert_logs_tab_severity: "Severidad",
    system_alert_logs_tab_name: "Nombre",
    system_alert_logs_tab_unit_label: "Etiqueta",
    system_alert_logs_tab_driver_name: "Conductor",
    system_alert_logs_tab_latitude: "Latitud",
    system_alert_logs_tab_longitude: "Longitud",
    system_alert_logs_tab_address: "Dirección",
    system_alert_logs_tab_landmark_name: "Punto de Referencia",
    system_alert_logs_tab_device_reading_id: "Id Reading Device",
    system_alert_logs_tab_linked_unit_label: "Etiqueta Dispositivo Linkeado",
    system_alert_logs_tab_title: "Logs de Alert del Sistema",
    system_alert_logs_tab_details: "Detalles",
    system_alert_logs_tab_contacts: "Contactos",
    system_alert_logs_tab_email: "Correo electrónico",
    system_alert_logs_tab_show_last_reading_info: "Mostrar información de la última lectura",
    system_alert_logs_tab_show_device_reading_info: "Mostrar información de lectura del dispositivo",
    system_alert_logs_tab_view_details: "Ver Detalles",
    system_alert_logs_tab_status: "Estado",
    system_alert_logs_tab_hdop: "HDOP",
    system_alert_logs_tab_rssi: "RSSI",
    system_alert_logs_tab_satellite_count: "Conteo de satélites",
    system_alert_logs_tab_hdop_ideal: "Ideal",
    system_alert_logs_tab_hdop_excellent: "Excelente",
    system_alert_logs_tab_hdop_good: "Buena",
    system_alert_logs_tab_hdop_moderate: "Moderada",
    system_alert_logs_tab_hdop_fair: "Justa",
    system_alert_logs_tab_hdop_poor: "Pobre",
    system_alert_logs_tab_hdop_unknown: "Desconocido",
    system_alert_logs_tab_hdop_no_signal: "Sin señal",

    system_alert_logs_graphic_view_button: "Ver Gráficos",

    system_alert_logs_graphic_view_title: "Gráficos de Alertas del Sistema",
    system_alert_logs_graphic_view_by_severity: "Por Severidad",
    system_alert_logs_graphic_view_total: "Total Alertas",
    system_alert_logs_graphic_view_by_type: "Por Tipo",
    system_alert_logs_tab_name: "Nombre",
    system_alert_logs_tab_type: "Tipo",
    system_alert_logs_tab_severity: "Severidad",

    system_alert_severity_high: "Alta",
    system_alert_severity_medium: "Media",
    system_alert_severity_low: "Baja",
}